import { ResponseError } from '../types/responseError';

export const transformErrors = (errors?: ResponseError[]) => {
  return {
    cancelErrorMessage:
      (errors && errors[0].message) || 'An error occurred. Please try again.',
    cancelErrorField: (errors && errors[0].field) || '',
  };
};
